module.exports = __webpack_public_path__ + "img/tips.b3a5652.png";